import { render, staticRenderFns } from "./VehicleHeadlightHeroPinButton.vue?vue&type=template&id=35cead23"
import script from "./VehicleHeadlightHeroPinButton.vue?vue&type=script&lang=js"
export * from "./VehicleHeadlightHeroPinButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports